<!-- 
HACCP情報を表示するパネルリスト
@props
  title : HACCP情報のタイトル（例：水揚げ、使用海水）
  json : 表示するHACCP情報
  schema : HACCP情報の変換パーサ（logic/parserのいずれか）
-->

<template>
  <v-card flat>
    <v-card-title>{{ title }}</v-card-title>
    <v-card-text class="d-flex flex-row flex-wrap" flat>
      <record-detail-panel
        :json="item"
        :schema="schema"
        v-for="item in displayData"
        :key="item.key"
        @pushMessage="$listeners['pushMessage']"
      ></record-detail-panel>
    </v-card-text>
  </v-card>
</template>

<script>
import RecordDetailPanel from "./record-detail-panel.vue";
import ParserBase from "../../logic/parser/parser-base";

export default {
  components: {
    "record-detail-panel": RecordDetailPanel,
  },
  props: {
    title: String,
    json: [Object, Array],
    schema: ParserBase,
  },
  computed: {
    displayData() {
      return this.json.filter((item) => this.schema.isCorrect(item));
    },
  },
};
</script>

<style></style>
